import React, { CSSProperties, HTMLAttributes } from 'react'
import styled, { keyframes } from 'styled-components'
import { useTheme as useStyledTheme } from 'styled-components'

const spinnerRotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const spinnerStroke = keyframes`
  0% { stroke-dashoffset: 600; }
  100% { stroke-dashoffset: 0; }
`

const SpinnerWrapper = styled.div<{
  $size: number
  $margin?: number
  $alignSelf?: CSSProperties['alignSelf']
}>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  margin: ${({ $margin }) => $margin}px;
  align-self: ${({ $alignSelf }) => $alignSelf};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`

const SpinnerSvg = styled.svg`
  width: 100%;
  height: 100%;
  animation: ${spinnerRotate} 2s linear infinite;
`

const SpinnerCircle = styled.circle<{ $strokeColor: string }>`
  fill: transparent;
  stroke: ${({ $strokeColor }) => $strokeColor};
  stroke-dasharray: 300;
  stroke-dashoffset: 600;
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-width: 12;
  animation: ${spinnerStroke} 1.6s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite;
`

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: number
  margin?: number
  alignSelf?: CSSProperties['alignSelf']
  color?: string
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 32,
  margin,
  alignSelf,
  color,
  ...rest
}) => {
  const theme = useStyledTheme()
  const strokeColor = color || theme?.colors?.iconGray

  return (
    <SpinnerWrapper $size={size} $margin={margin} $alignSelf={alignSelf} {...rest}>
      <SpinnerSvg viewBox="0 0 150 150">
        <SpinnerCircle cx="75" cy="75" r="60" $strokeColor={strokeColor ?? '#c1c4d6'} />
      </SpinnerSvg>
    </SpinnerWrapper>
  )
}
